export class GlobalConstants {
  static readonly maxEpoch = +8640000000000000;
  static readonly minEpoch = -8640000000000000;

  static readonly maxDate = new Date(GlobalConstants.maxEpoch);
  static readonly minDate = new Date(GlobalConstants.minEpoch);

  static readonly DATA_EXPLORER_HELP_PATH = 'https://www.cde.ca.gov/ds/fd/dv/';

  private constructor() {}
}
